import { TEntityOverride } from 'src/types'

import CreateRoleTemplate from './CreateRoleTemplate/CreateRoleTemplate'
import EditRoleTemplate from './EditRoleTemplate/EditRoleTemplate'

const override: TEntityOverride = {
  titleField: 'name',
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
      authorizations: {
        hidden: true,
      },
    },
  },
  create: {
    displayedComponent: CreateRoleTemplate,
    properties: {
      description: {
        multiline: true,
      },
    },
  },
  edit: {
    displayedComponent: EditRoleTemplate,
    properties: {
      description: {
        multiline: true,
      },
    },
  },
  list: {
    properties: {},
  },
}

export default override
